module.exports = __webpack_public_path__ + "img/pic_my_top@2x.259cab9f.png";